<!-- <button class="upload-btn" (click)="onClickSave()">
  <p>Save</p>
</button> -->
<div class="w-full">
  <div
    class="relative w-full flex flex-row justify-between items-center bg-gray-200 dark:bg-gray-700 text-black dark:text-white p-4 rounded"
  >
    <p class="text-sm lg:text-lg">Create preset</p>
    <button class="disabled:bg-[#bfbfbf]" (click)="onCreateClick()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M12 5V19M5 12H19"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>
</div>
<div class="card w-full flex flex-col gap-4">
  <p class="text-xs lg:text-base text-black dark:text-white font-semibold mb-1 lg:mb-2">
    Saved preset
  </p>
  @for (preset of presets; track preset) {
    <div class="preset-field">
      <button class="w-full h-full" (click)="onClickPreset(preset)">
        <img [src]="preset.thumbnail" [alt]="preset.title" />
      </button>
      <div class="preset-title-card">
        <p>{{ preset.title }}</p>
        <div class="w-full flex flex-row justify-between">
          <div></div>
          <button class="delete-button" (click)="deletePreset($index)">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
            >
              <path
                d="M8 3V2.6C8 2.03995 8 1.75992 7.89101 1.54601C7.79513 1.35785 7.64215 1.20487 7.45399 1.10899C7.24008 1 6.96005 1 6.4 1H5.6C5.03995 1 4.75992 1 4.54601 1.10899C4.35785 1.20487 4.20487 1.35785 4.10899 1.54601C4 1.75992 4 2.03995 4 2.6V3M5 5.75V8.25M7 5.75V8.25M1.5 3H10.5M9.5 3V8.6C9.5 9.44008 9.5 9.86012 9.33651 10.181C9.1927 10.4632 8.96323 10.6927 8.68099 10.8365C8.36012 11 7.94008 11 7.1 11H4.9C4.05992 11 3.63988 11 3.31901 10.8365C3.03677 10.6927 2.8073 10.4632 2.66349 10.181C2.5 9.86012 2.5 9.44008 2.5 8.6V3"
                stroke="black"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  }
</div>
